export default class MsgReadStatusParser {
    static processReadStatusMsg(clientStater, readStatusMsg) {
        if (clientStater.opts.onReadStatusMsg) {
            clientStater.opts.onReadStatusMsg({ code: 200, data: readStatusMsg });
        }
    }
}
//# sourceMappingURL=msgReadStatusParser.js.map